<template>
  <div class="bordered-layout">
    <!-- FILE FILTER -->
    <b-card
      no-body
      class="mb-1"
    >
      <b-card-body>
        <div class="row">
          <div class="col-12 col-md-3">
            <label>Thư mục</label>
            <b-form-select
              v-model="categoryId"
              :options="categoryOptions"
              value-field="id"
              text-field="name"
            />
          </div>
          <div class="col-12 col-md-3">
            <b-form-group
              label="Từ ngày"
              label-for="startDate"
            >
              <div class="input-group">
                <flat-pickr
                  ref="startDateRef"
                  v-model="startDate"
                  class="form-control"
                  :config="configDate"
                  placeholder="Từ ngày"
                  @on-change="searchFiles"
                  @on-close="searchFiles"
                />
                <div class="input-group-append">
                  <button
                    v-if="!startDate"
                    class="input-group-text"
                    type="button"
                    @click.prevent="openStartDate"
                  >
                    <feather-icon icon="CalendarIcon" />
                  </button>
                  <button
                    v-if="startDate"
                    class="input-group-text"
                    type="button"
                    @click.prevent="clearStartDate"
                  >
                    <feather-icon icon="XIcon" />
                  </button>
                </div>
              </div>
            </b-form-group>
          </div>
          <div class="col-12 col-md-3">
            <b-form-group
              label="Đến ngày"
              label-for="endDate"
            >
              <div class="input-group">
                <flat-pickr
                  ref="endDateRef"
                  v-model="endDate"
                  class="form-control"
                  :config="configDate"
                  placeholder="Đến ngày"
                  @on-change="searchFiles"
                  @on-close="searchFiles"
                />
                <div class="input-group-append">
                  <button
                    v-if="!endDate"
                    class="input-group-text"
                    type="button"
                    @click.prevent="openEndDate"
                  >
                    <feather-icon icon="CalendarIcon" />
                  </button>
                  <button
                    v-if="endDate"
                    class="input-group-text"
                    type="button"
                    @click.prevent="clearEndDate"
                  >
                    <feather-icon icon="XIcon" />
                  </button>
                </div>
              </div>
            </b-form-group>
          </div>
          <div class="col-12 col-md-3">
            <b-form-group
              label="Từ khóa"
              label-for="searchInput"
            >
              <b-input-group>
                <b-form-input
                  v-model="localSearchQuery"
                  class="d-inline-block"
                  placeholder="Tên,file"
                  @keyup.enter="updateSearchQuery"
                />
                <b-input-group-append>
                  <b-button
                    variant="primary"
                    @click="searchFiles"
                  >
                    <feather-icon icon="SearchIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <!-- FILE UPLOAD -->
    <file-upload
      ref="uploadMamFileRef"
      class="mb-1"
      :auto-upload="true"
      :remove-file-after-success="true"
      :close-modal-after-all-success="false"
      input-id="input-upload-mam-file"
      @on-uploaded-all="fetchFiles"
    />

    <!-- FILE LIST -->
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card
        no-body
        class="mb-0"
      >
        <vue-good-table
          ref="tableGood"
          :columns="columns"
          :rows="itemsData"
          :rtl="direction"
          :total-rows="dataMeta.of"
          :search-options="{
            enabled: false,
            externalQuery: searchQuery
          }"
          :select-options="{
            enabled: true,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'dòng được chọn',
            clearSelectionText: 'xóa',
            disableSelectInfo: false, // disable the select info panel on top
            selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }"
          :pagination-options="{
            enabled: true,
            perPage: perPage
          }"
          :sort-options="{
            enabled: false,
          }"
          @on-selected-rows-change="onSelectedRowChange"
          @on-page-change="onPageChange"
        >
          <template slot="selected-row-actions">
            <b-button
              size="sm"
              variant="outline-primary"
              @click="addSelectedFileToEditor"
            >
              <feather-icon icon="PlusIcon" /> Chèn các file đã chọn
            </b-button>
          </template>
          <template
            slot="table-row"
            slot-scope="props"
          >
            <!-- Column: Name -->
            <span
              v-if="props.column.field === 'file'"
              class="text-nowrap"
            >
              <span class="text-wrap">{{ props.row.file }}</span>
            </span>
            <!-- Column: Type -->
            <span v-else-if="props.column.field === 'type'">
              {{ getTypeName(props.row.type) }}
            </span>
            <!-- Column: Created At -->
            <span v-else-if="props.column.field === 'created_at'">
              {{ formatDate(props.row.created_at) }}
            </span>
            <!-- Column: Mam Status -->
            <span v-else-if="props.column.field === 'mam_status'">
              <b-badge
                :variant="getMamStatusVariant(props.row.mam_status, props.row.file_proxy)"
                pill
                class="badge-round mr-1"
              >
                {{ getMamStatusName(props.row.mam_status, props.row.file_proxy) }}
              </b-badge>
            </span>
            <!-- Column: Speech to text -->
            <span v-else-if="props.column.field === 'transcrible'">
              <b-button
                v-if="props.row.transcribe === 4"
                size="sm"
                class="ml"
                :variant="resolveTranscỉbeVariant(props.row.transcribe)"
                @click="addTextToEditor(props.row)"
              >
                <b-spinner
                  v-if="props.row.loading"
                  small
                />
                <feather-icon
                  v-else
                  icon="PlusIcon"
                />
                Chèn văn bản vào tin
              </b-button>
              <b-button
                v-else
                size="sm"
                class="ml"
                :variant="resolveTranscỉbeVariant(props.row.transcribe)"
                :disabled="props.row.transcribe === 2 || props.row.transcribe === 3"
                @click="startTranscribe(props.row)"
              >
                <b-spinner
                  v-if="props.row.transcribe === 2 || props.row.transcribe === 3"
                  small
                />
                <feather-icon
                  v-else
                  icon="RotateCwIcon"
                />
                {{ resolveTranscribeText(props.row.transcribe) }}
              </b-button>
            </span>
            <!-- Column: Action -->
            <span v-else-if="props.column.field === 'action'">
              <b-button
                size="sm"
                class=""
                variant="outline-primary"
                @click="addFileToEditor(props.row)"
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
            </span>

            <!-- Column: Common -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>

          <!-- pagination -->
          <template
            slot="pagination-bottom"
            slot-scope="props"
          >
            <div class="d-flex justify-content-between flex-wrap p-1">
              <div class="d-flex align-items-center">
                <span class="text-nowrap ">
                  Hiển thị 1 đến
                </span>
                <b-form-select
                  v-model="perPage"
                  :options="['10', '20', '30', '50']"
                  class="mx-1"
                  @input="(value) => props.perPageChanged({ currentPerPage: value })"
                />
                <span class="text-nowrap"> của {{ props.total }} mục </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="perPage"
                  first-number
                  last-number
                  prev-class="prev-item"
                  next-class="next-item"
                  class="m-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BOverlay, BCard, BCardBody, BRow, BCol, BTable, BButton, BFormCheckbox, BFormInput, BInputGroup, BInputGroupAppend,
  BFormGroup, BBadge, BFormSelect, BFormSelectOption, BPagination, BSpinner,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { insertFileToEditor } from '@/libs/initTinymce';
import { ref } from '@vue/composition-api';
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import { formatDate } from '@/libs/helper';
import { showToast } from '@/@core/utils/utils';
import { getToken } from '@/auth/utils';
import tinymce from 'tinymce';
import FileUpload from './FileUpload.vue';
import useFileManager from '../useFileManager';
import useFiles from '../useFiles';

export default {
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
    BFormInput,
    BInputGroup,
    BCardBody,
    BFormGroup,
    BInputGroupAppend,
    BFormSelect,
    BSpinner,
    BPagination,
    flatPickr,
    FileUpload,
    VueGoodTable,
  },
  props: {
    inEditor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localSearchQuery: '',
      category_id: 0,
      categoryOptions: [],
      columns: [
        {
          label: '#',
          field: 'id',
        },
        {
          label: 'File',
          field: 'file',
        },
        {
          label: 'Loại',
          field: 'type',
        },
        {
          label: 'Ngày tạo',
          field: 'created_at',
        },
        {
          label: 'Trạng thái',
          field: 'mam_status',
        },
        {
          label: 'Rải băng',
          field: 'transcrible',
        },
        {
          label: 'Chèn',
          field: 'action',
        },
      ],
      selectedRows: [],
      searchTerm: '',
    }
  },
  setup() {
    const {
      statusNames,
      statusVariants,
      getMamStatusVariant,
      getMamStatusName,
      getStatusVariant,
      getStatusName,
      getTranscribeStatusName,
      getTypeName,
      convertSize,
      convertDate,
    } = useFiles();

    const itemFiles = ref([]);

    const {
      loading,
      currentPage,
      perPage,
      totalEntries,
      categoryId,
      searchQuery,
      configDate,
      tableColumns,
      dataMeta,
      getCatOptions,
      fetchFiles,
      deleteFile,
      autoFetchFiles,
      itemsData,
      startDate,
      endDate,
      refFileListTable,
    } = useFileManager();

    return {
      loading,
      currentPage,
      perPage,
      totalEntries,
      categoryId,
      searchQuery,
      configDate,
      tableColumns,
      dataMeta,
      itemsData,
      getCatOptions,
      fetchFiles,
      // files
      statusNames,
      statusVariants,
      getStatusVariant,
      getStatusName,
      getMamStatusVariant,
      getMamStatusName,
      getTranscribeStatusName,
      getTypeName,
      convertSize,
      convertDate,
      deleteFile,
      autoFetchFiles,
      startDate,
      endDate,
      refFileListTable,
      itemFiles,

    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  watch: {
    // '$store.state.files.show_all_category': function () {
    //   this.fetchFiles();
    // },
  },
  mounted() {
    this.getAllCategory();
    this.$store.dispatch('files/setState', {
      file_info: null,
    });
    // if (this.autoFetchFiles) {
    this.fetchFiles();
    // }
  },
  methods: {
    updateSearchQuery() {
      this.searchQuery = this.localSearchQuery;
      this.searchFiles();
    },
    onPageChange(params) {
      this.currentPage = params.currentPage;
    },
    clearStartDate() {
      this.startDate = '';
    },
    clearEndDate() {
      this.endDate = '';
    },
    openStartDate() {
      this.$refs.startDateRef.$el.focus();
    },
    openEndDate() {
      this.$refs.endDateRef.$el.focus();
    },
    searchFiles() {
      this.fetchFiles();
    },
    addFileToEditor(item) {
      this.$store.dispatch('files/setState', {
        show_file_manager: false,
        auto_fetch_files: false,
        // file_from_editor: false,
        file_info: item,
      });
      insertFileToEditor(item);
    },
    getAllCategory() {
      this.newTree = [];
      this.$store.dispatch('files/setState', {
        category_items: [],
        loading: true,
      });
      this.$store.dispatch('files/fetchAllCategory', { flatten: 1 })
        .then((res) => {
          this.loading = false
          if (res.status === 200) {
            if (res.data.code === 200) {
              this.categoryOptions = this.getCatOptions(res.data.data);
            }
          }
        })
    },
    confirmDelete(id) {
      this.$swal({
        title: 'Bạn chắc muốn xóa?',
        text: 'Xóa dữ liệu sẽ ảnh hưởng đến các chức năng khác trong hệ thống!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.deleteFile(id);
        }
      })
    },
    onSelectedRowChange() {
      this.selectedRows = this.$refs.tableGood.selectedRows;
    },
    addSelectedFileToEditor() {
      if (this.selectedRows.length) {
        this.selectedRows.forEach(file => {
          this.addFileToEditor(file);
        });
      }
    },
    formatDate(date) {
      return formatDate(date)
    },
    resolveTranscribeText(transcribe) {
      let text = '';
      switch (transcribe) {
        case 5:
        case 6:
          text = 'Đã có lỗi chuyển văn bản';
          break;
        case 4:
          text = 'Đã chuyển sang văn bản';
          break;
        case 2:
        case 3:
          text = 'Đang chuyển sang văn bản';
          break;
        default:
          text = 'Chuyển sang văn bản';
          break;
      }
      return text;
    },
    resolveTranscỉbeVariant(transcribe) {
      return transcribe === 4 ? 'outline-success' : 'outline-primary';
    },
    updateTranscribeStatus(fileData, status) {
      fileData.transcribe = status;
      fileData.status = status;
    },
    startTranscribe(fileData) {
      console.log('startTranscribe fileData', fileData);
      if (fileData.transcribe === 2 || fileData.transcribe === 3) {
        showToast('File đang được xử lý. Vui lòng đợi trong giây lát', { variant: 'success' });
      } else if (fileData.transcribe === 0 || fileData.transcribe === 1 || fileData.transcribe === 5 || fileData.transcribe === 6) {
        const payload = {
          fileData: {
            id: fileData.id,
            fileName: fileData.file,
            file: fileData.file_local,
            access_token: getToken(),
          },
          file: fileData.file_local,
          provider: 'aimes',
          stage: 'upload_and_convert',
        }
        this.updateTranscribeStatus(fileData, 2);
        store.dispatch('speech/startTranscribe', payload)
          .then(response => {
            this.loading = false
            const { code, message, data } = response.data;
            if (code === 200) {
              this.updateTranscribeStatus(fileData, data.status);
            } else {
              showToast(message);
            }
          })
      }
    },
    getFileTranscribe(fileData) {
      fileData.loading = true;
      store.dispatch('speech/getFileTranscribe', {
        file_id: fileData.id,
      })
        .then(response => {
          fileData.loading = false;
          if (response.data.code === 200) {
            console.log('response.data.data', response.data.data);
            let { text, status } = response.data.data;
            this.updateTranscribeStatus(fileData, status);
            text = text.replace(/(<([^>]+)>)/gi, '');
            // this.$emit('updateSpeechToText', text.replace(/(<([^>]+)>)/gi, ''));
            console.log('getFileTranscribe status: ', status);

            this.$store.dispatch('files/setState', {
              show_file_manager: false,
              file_info: fileData,
            });
            tinymce.activeEditor.insertContent(`${text}<p></p>`);
          } else {
            this.updateTranscribeStatus(fileData, 5);
            showToast(response.data.message);
          }
        })
    },
    addTextToEditor(fileData) {
      if (this.inEditor) {
        this.getFileTranscribe(fileData);
      }
    },
  },

}
</script>
<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
